/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

export const ERROR_CODES_400S = {
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  UNAUTHORIZED: 'UNAUTHORIZED',
  ACCESS_DENIED: 'ACCESS_DENIED',
  ERR_EMPTY_VALUE: 'ERR_EMPTY_VALUE',
  NOT_FOUND: 'NOT_FOUND',
  ERR_FILE_MAX: 'ERR_FILE_MAX',
  ERR_FILE_TYPE: 'ERR_FILE_TYPE',
  ERR_BOOLEAN: 'ERR_BOOLEAN',
  ERR_EMAIL_FORMAT: 'ERR_EMAIL_FORMAT',
  ERR_NULL_VALUE: 'ERR_NULL_VALUE',
  ERR_UNIQUE: 'ERR_UNIQUE',
  ERR_AFTER: 'ERR_AFTER',
  ERR_ALPHA_DASH: 'ERR_ALPHA_DASH',
  ERR_DATE: 'ERR_DATE',
  ERR_DATE_FORMAT: 'ERR_DATE_FORMAT',
  ERR_DIGITS: 'ERR_DIGITS',
  ERR_NUMBER_MIN: 'ERR_NUMBER_MIN',
  ERR_STRING_MIN: 'ERR_STRING_MIN',
  ERR_NUMBER: 'ERR_NUMBER',
  ERR_INVALID_FORMAT: 'ERR_INVALID_FORMAT',
  VALUE_MUST_SAME_AS: 'VALUE_MUST_SAME_AS',
  ERR_INVALID_TENANT: 'ERR_INVALID_TENANT',
  ERR_INVALID_TENANT_ACCESS: 'ERR_INVALID_TENANT_ACCESS',
  ERR_INVALID_VALUE: 'ERR_INVALID_VALUE',
  INVALID_VALUE_CONTAINS_NAME: 'INVALID_VALUE_CONTAINS_NAME',
  NOT_EXISTS_IN_DB: 'NOT_EXISTS_IN_DB',
  ERR_AUTH_REQUIRED: 'ERR_AUTH_REQUIRED',
  ERR_USER_ALREADY_EXISTS: 'ERR_USER_ALREADY_EXISTS',
  USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
  ERR_PAYMENT_FAILED: 'ERR_PAYMENT_FAILED',
  ERR_CARD_DETAIL_CANCEL_SUBSCRIPTION: 'ERR_CARD_DETAIL_CANCEL_SUBSCRIPTION',
  ERR_USER_ALREADY_ENROLLED_IN_SAME_PROGRAM: 'ERR_USER_ALREADY_ENROLLED_IN_SAME_PROGRAM',
  ERR_COURSE_GROUP_ITEM_EXIST_FOR_COURSE: 'ERR_COURSE_GROUP_ITEM_EXIST_FOR_COURSE',
  ERR_COURSE_GROUP_ITEM_EXIST_FOR_COURSE_GROUP: 'ERR_COURSE_GROUP_ITEM_EXIST_FOR_COURSE_GROUP',
  ERR_COURSE_EXIST_FOR_SUBJECT: 'ERR_COURSE_EXIST_FOR_SUBJECT',
  ERR_PROGRAM_TRANSCRIPT_EXIST_FOR_TRANSCRIPT_TEMPLATE:
    'ERR_PROGRAM_TRANSCRIPT_EXIST_FOR_TRANSCRIPT_TEMPLATE',
  ERR_COURSE_GROUP_EXIST_FOR_PROGRAM: 'ERR_COURSE_GROUP_EXIST_FOR_PROGRAM',
  ERR_PROGRAM_EXPIRED: 'ERR_PROGRAM_EXPIRED',
  WALLET_NOT_EXISTS: 'AR51_PAYMENT:WALLET_NOT_EXISTS',
  INVALID_CURRENT_PASSWORD: 'INVALID_CURRENT_PASSWORD',
  SAME_PASSWORD: 'SAME_PASSWORD',
  INVALID_PASSWORD: 'INVALID_PASSWORD',
  ERR_INVALID_AMOUNT: 'ERR_INVALID_AMOUNT',
  ERR_EMAIL_ALREADY_EXISTS: 'ERR_EMAIL_ALREADY_EXISTS',
  ERR_NUMBER_OF_COURSES: 'ERR_NUMBER_OF_COURSES',
  VOUCHER_USED: 'VOUCHER_USED',
  INVALID_VOUCHER_CODE: 'INVALID_VOUCHER_CODE',
  VOUCHER_EXPIRED: 'VOUCHER_EXPIRED',
  INVALID_FROM_DATE: 'INVALID_FROM_DATE',
  EXCEEDED_VOUCHER_AMOUNT: 'EXCEEDED_VOUCHER_AMOUNT',
  MIN_AGE: 'MIN_AGE',
}

export const mapFieldErrors = function (errors) {
  const err = {}
  Object.keys(errors).forEach((key) => {
    const errorCode = errors[key][0] || ''
    const splitted = errorCode.split(':')
    Object.keys(ERROR_CODES_400S).every((code) => {
      if (splitted[0] === code) {
        err[key] = `error:${ERROR_CODES_400S[code].toLocaleLowerCase()}`
        return false
      }
      return true
    })
  })
  return err
}

export const mapGeneralErrors = function (error, defaultMessage) {
  let err = defaultMessage
  Object.keys(ERROR_CODES_400S).every((code) => {
    if (error === code) {
      err = `error:${ERROR_CODES_400S[code].toLocaleLowerCase()}`
      return false
    }
    return true
  })
  return err
}
